export default __webpack_public_path__ + "static/media/avatar_6.55bf1e63.svg";